export default __webpack_public_path__ + "static/media/logo-bananinha.300e164f.png";